import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { EuiSpacer } from '@elastic/eui';
import NavButtons from 'components/Indoor_Cameras/IN-8015_HD/NavButtons';
import CompareFlyout from 'components/Products/Compare/CompareIndoorFlyout';
import IndoorData from 'components/Products/Flyouts/Graphs/IndoorGraphsFlyout';
import TableFeatures from 'components/Indoor_Cameras/IN-8015_HD/TableFeatures';
import ImageQGallery from 'components/Indoor_Cameras/IN-8015_HD/ImageQGallery';
import ImageQCards from 'components/Indoor_Cameras/IN-8015_HD/ImageQCards';
import SmartCards from 'components/Products/Flyouts/Cards/8015Cards';
import RadarGraphCard from 'components/Products/RadarGraphs/in8015-radargraph-grid';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  OutboundLink,
  EuiSpacer,
  NavButtons,
  CompareFlyout,
  IndoorData,
  TableFeatures,
  ImageQGallery,
  ImageQCards,
  SmartCards,
  RadarGraphCard,
  BreadCrumbs,
  SEOHelmet,
  React
};